import { StatusCellVariant } from "~/components/Cells/StatusCell";
import { WorkflowStatus } from "~/operations";

export const getWorkflowStatusCellVariant = (
  status: WorkflowStatus,
): StatusCellVariant => {
  switch (status) {
    case WorkflowStatus.Fixed:
      return "success";
    case WorkflowStatus.Canceled:
    case WorkflowStatus.Failed:
      return "error";
    default:
      return "default";
  }
};

export const getWorkflowStatusCellLabel = (status: WorkflowStatus): string => {
  switch (status) {
    case WorkflowStatus.Fixed:
      return "Fixed";
    case WorkflowStatus.Canceled:
      return "Canceled";
    case WorkflowStatus.Failed:
      return "Failed";
    case WorkflowStatus.Pending:
      return "Pending";
    case WorkflowStatus.PrCreated:
      return "PR Created";
    case WorkflowStatus.PrMerged:
      return "PR Merged";
    default:
      return "Unknown";
  }
};

export const getWorkflowStatusCellProgress = (
  status: WorkflowStatus,
): number => {
  switch (status) {
    case WorkflowStatus.Fixed:
      return 100;
    case WorkflowStatus.Canceled:
    case WorkflowStatus.Failed:
      return 0;
    case WorkflowStatus.Pending:
      return 25;
    case WorkflowStatus.PrCreated:
      return 50;
    case WorkflowStatus.PrMerged:
      return 75;
    default:
      return 0;
  }
};
